import { render, staticRenderFns } from "./integralGift.vue?vue&type=template&id=cf6b1472&scoped=true&"
import script from "./integralGift.vue?vue&type=script&lang=js&"
export * from "./integralGift.vue?vue&type=script&lang=js&"
import style0 from "./integralGift.vue?vue&type=style&index=0&id=cf6b1472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6b1472",
  null
  
)

export default component.exports